import { render } from "./AddonViewProcessing.vue?vue&type=template&id=01a05446&scoped=true&ts=true"
import script from "./AddonViewProcessing.vue?vue&type=script&lang=ts"
export * from "./AddonViewProcessing.vue?vue&type=script&lang=ts"

import "./AddonViewProcessing.vue?vue&type=style&index=0&id=01a05446&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1361425700/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a05446"]])

export default __exports__